"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * BFF Mobile Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateStreamApi = exports.UpdateStreamApiFactory = exports.UpdateStreamApiFp = exports.UpdateStreamApiAxiosParamCreator = exports.OnboardingApi = exports.OnboardingApiFactory = exports.OnboardingApiFp = exports.OnboardingApiAxiosParamCreator = exports.InitialStateApi = exports.InitialStateApiFactory = exports.InitialStateApiFp = exports.InitialStateApiAxiosParamCreator = exports.DevicesApi = exports.DevicesApiFactory = exports.DevicesApiFp = exports.DevicesApiAxiosParamCreator = exports.UpdateEventTypeEnum = exports.IPointTypeEnum = exports.IDevicePayloadStatusEnum = exports.DeviceNetworkStatusEnum = exports.DeviceCommandStatusEnum = exports.CommandTypeEnum = exports.ChangeTypeEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.ChangeTypeEnum = {
    CREATED: 'CREATED',
    UPDATED: 'UPDATED',
    DELETED: 'DELETED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CommandTypeEnum = {
    SET_ZONE: 'SET_ZONE',
    EXIT_ZONE: 'EXIT_ZONE',
    PAUSE: 'PAUSE',
    DELETE_COMMANDS: 'DELETE_COMMANDS',
    CLEAR_STATE: 'CLEAR_STATE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DeviceCommandStatusEnum = {
    NOT_SYNCED: 'NOT_SYNCED',
    SYNCING: 'SYNCING',
    SYNCED: 'SYNCED',
    FAILED_TO_SYNC: 'FAILED_TO_SYNC',
    ACTIVE: 'ACTIVE',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DeviceNetworkStatusEnum = {
    GOOD: 'GOOD',
    BAD: 'BAD'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.IDevicePayloadStatusEnum = {
    NOT_SYNCED: 'NOT_SYNCED',
    SYNCING: 'SYNCING',
    SYNCED: 'SYNCED',
    FAILED_TO_SYNC: 'FAILED_TO_SYNC'
};
exports.IPointTypeEnum = {
    POINT: 'Point'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.UpdateEventTypeEnum = {
    CATTLE_CHANGE: 'CATTLE_CHANGE',
    CATTLE_DEVICE_ASSIGNMENT_CHANGE: 'CATTLE_DEVICE_ASSIGNMENT_CHANGE',
    DEVICE_SYNC_STATUS_CHANGE: 'DEVICE_SYNC_STATUS_CHANGE',
    BREAK_FENCE_SYNC_STATUS_CHANGE: 'BREAK_FENCE_SYNC_STATUS_CHANGE',
    DEVICE_STATUS_CHANGE: 'DEVICE_STATUS_CHANGE',
    BREAK_FENCE_CHANGE: 'BREAK_FENCE_CHANGE',
    BREAK_FENCE_GROUP_CHANGE: 'BREAK_FENCE_GROUP_CHANGE',
    DEVICE_LOCATION_CHANGE: 'DEVICE_LOCATION_CHANGE',
    MOB_CHANGE: 'MOB_CHANGE',
    PASTURE_PADDOCK_CHANGE: 'PASTURE_PADDOCK_CHANGE',
    PASTURE_MOB_PARAMETERS_CHANGE: 'PASTURE_MOB_PARAMETERS_CHANGE',
    DEVICE_NETWORK_STATUS_CHANGE: 'DEVICE_NETWORK_STATUS_CHANGE',
    DEVICE_NETWORK_STATUS_ACTUAL_CHANGE: 'DEVICE_NETWORK_STATUS_ACTUAL_CHANGE',
    DEVICE_DISABLEMENT_STATUS_CHANGE: 'DEVICE_DISABLEMENT_STATUS_CHANGE',
    DEVICE_PAUSE_SYNC_STATUS_CHANGE: 'DEVICE_PAUSE_SYNC_STATUS_CHANGE',
    DEVICE_CONTROL_STATUS_CHANGE: 'DEVICE_CONTROL_STATUS_CHANGE',
    SHIFT_CHANGE: 'SHIFT_CHANGE',
    COW_SHIFT_CHANGE: 'COW_SHIFT_CHANGE',
    FARM_STATUS_CHANGE: 'FARM_STATUS_CHANGE',
    CATTLE_BREEDING_CHANGE: 'CATTLE_BREEDING_CHANGE',
    INCIDENT_CHANGE: 'INCIDENT_CHANGE',
    COW_INCIDENT_CHANGE: 'COW_INCIDENT_CHANGE',
    TASK_CHANGE: 'TASK_CHANGE',
    COW_HEALTH_FLAGGED_EVENT_CHANGE: 'COW_HEALTH_FLAGGED_EVENT_CHANGE',
    GRAZING_HEATMAP_CHANGE: 'GRAZING_HEATMAP_CHANGE'
};
/**
 * DevicesApi - axios parameter creator
 * @export
 */
var DevicesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Endpoint to ingest device metrics batch
         * @param {IDeviceNotificationBatchRequestDTO} iDeviceNotificationBatchRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleDeviceMetricsBatch: function (iDeviceNotificationBatchRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'iDeviceNotificationBatchRequestDTO' is not null or undefined
                    (0, common_1.assertParamExists)('handleDeviceMetricsBatch', 'iDeviceNotificationBatchRequestDTO', iDeviceNotificationBatchRequestDTO);
                    localVarPath = "/bff-mobile/device-metrics-batch";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iDeviceNotificationBatchRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DevicesApiAxiosParamCreator = DevicesApiAxiosParamCreator;
/**
 * DevicesApi - functional programming interface
 * @export
 */
var DevicesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DevicesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Endpoint to ingest device metrics batch
         * @param {IDeviceNotificationBatchRequestDTO} iDeviceNotificationBatchRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleDeviceMetricsBatch: function (iDeviceNotificationBatchRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.handleDeviceMetricsBatch(iDeviceNotificationBatchRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DevicesApiFp = DevicesApiFp;
/**
 * DevicesApi - factory interface
 * @export
 */
var DevicesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DevicesApiFp)(configuration);
    return {
        /**
         *
         * @summary Endpoint to ingest device metrics batch
         * @param {IDeviceNotificationBatchRequestDTO} iDeviceNotificationBatchRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleDeviceMetricsBatch: function (iDeviceNotificationBatchRequestDTO, options) {
            return localVarFp.handleDeviceMetricsBatch(iDeviceNotificationBatchRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DevicesApiFactory = DevicesApiFactory;
/**
 * DevicesApi - object-oriented interface
 * @export
 * @class DevicesApi
 * @extends {BaseAPI}
 */
var DevicesApi = /** @class */ (function (_super) {
    __extends(DevicesApi, _super);
    function DevicesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Endpoint to ingest device metrics batch
     * @param {IDeviceNotificationBatchRequestDTO} iDeviceNotificationBatchRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.handleDeviceMetricsBatch = function (iDeviceNotificationBatchRequestDTO, options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).handleDeviceMetricsBatch(iDeviceNotificationBatchRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DevicesApi;
}(base_1.BaseAPI));
exports.DevicesApi = DevicesApi;
/**
 * InitialStateApi - axios parameter creator
 * @export
 */
var InitialStateApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Proxy endpoint to retrieve break fence sync status after checking sync hasn\'t completed
         * @param {Array<string>} [breakFenceIds] List of breakFenceIds to retrieve sync statuses for, if null will retrieve all for farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBreakFenceSyncStatuses: function (breakFenceIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/bff-mobile/break-fence-sync-statuses";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (breakFenceIds) {
                        localVarQueryParameter['breakFenceIds'] = breakFenceIds;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Endpoint to retrieve device control statuses for devices that have unconfirmed control setting changes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDeviceControlStatuses: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/bff-mobile/device-control-statuses";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieve all cattle locations for the context farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDeviceLocations: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/bff-mobile/device-locations";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Endpoint to retrieve device pause sync statuses for devices that have a sync in progress
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listDevicePauseSyncStatuses: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/bff-mobile/device-pause-sync-statuses";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Proxy endpoint to retrieve device sync statuses filtering out break to breaks and already synced commands
         * @param {Array<string>} [serialNumbers] List of serialNumbers to retrieve sync statuses for, if null will retrieve all for farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDeviceSyncStatuses: function (serialNumbers, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/bff-mobile/device-sync-statuses";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (serialNumbers) {
                        localVarQueryParameter['serialNumbers'] = serialNumbers;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieve device disablement status for all devices in the context farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDevicesDisablementStatus: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/bff-mobile/devices-disablement-status";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieve network status for all devices in the context farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDevicesNetworkStatus: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/bff-mobile/devices-network-status";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.InitialStateApiAxiosParamCreator = InitialStateApiAxiosParamCreator;
/**
 * InitialStateApi - functional programming interface
 * @export
 */
var InitialStateApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.InitialStateApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Proxy endpoint to retrieve break fence sync status after checking sync hasn\'t completed
         * @param {Array<string>} [breakFenceIds] List of breakFenceIds to retrieve sync statuses for, if null will retrieve all for farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBreakFenceSyncStatuses: function (breakFenceIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listBreakFenceSyncStatuses(breakFenceIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Endpoint to retrieve device control statuses for devices that have unconfirmed control setting changes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDeviceControlStatuses: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listDeviceControlStatuses(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve all cattle locations for the context farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDeviceLocations: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listDeviceLocations(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Endpoint to retrieve device pause sync statuses for devices that have a sync in progress
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listDevicePauseSyncStatuses: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listDevicePauseSyncStatuses(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Proxy endpoint to retrieve device sync statuses filtering out break to breaks and already synced commands
         * @param {Array<string>} [serialNumbers] List of serialNumbers to retrieve sync statuses for, if null will retrieve all for farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDeviceSyncStatuses: function (serialNumbers, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listDeviceSyncStatuses(serialNumbers, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve device disablement status for all devices in the context farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDevicesDisablementStatus: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listDevicesDisablementStatus(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve network status for all devices in the context farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDevicesNetworkStatus: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listDevicesNetworkStatus(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.InitialStateApiFp = InitialStateApiFp;
/**
 * InitialStateApi - factory interface
 * @export
 */
var InitialStateApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.InitialStateApiFp)(configuration);
    return {
        /**
         *
         * @summary Proxy endpoint to retrieve break fence sync status after checking sync hasn\'t completed
         * @param {Array<string>} [breakFenceIds] List of breakFenceIds to retrieve sync statuses for, if null will retrieve all for farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBreakFenceSyncStatuses: function (breakFenceIds, options) {
            return localVarFp.listBreakFenceSyncStatuses(breakFenceIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Endpoint to retrieve device control statuses for devices that have unconfirmed control setting changes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDeviceControlStatuses: function (options) {
            return localVarFp.listDeviceControlStatuses(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve all cattle locations for the context farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDeviceLocations: function (options) {
            return localVarFp.listDeviceLocations(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Endpoint to retrieve device pause sync statuses for devices that have a sync in progress
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listDevicePauseSyncStatuses: function (options) {
            return localVarFp.listDevicePauseSyncStatuses(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Proxy endpoint to retrieve device sync statuses filtering out break to breaks and already synced commands
         * @param {Array<string>} [serialNumbers] List of serialNumbers to retrieve sync statuses for, if null will retrieve all for farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDeviceSyncStatuses: function (serialNumbers, options) {
            return localVarFp.listDeviceSyncStatuses(serialNumbers, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve device disablement status for all devices in the context farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDevicesDisablementStatus: function (options) {
            return localVarFp.listDevicesDisablementStatus(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve network status for all devices in the context farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDevicesNetworkStatus: function (options) {
            return localVarFp.listDevicesNetworkStatus(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.InitialStateApiFactory = InitialStateApiFactory;
/**
 * InitialStateApi - object-oriented interface
 * @export
 * @class InitialStateApi
 * @extends {BaseAPI}
 */
var InitialStateApi = /** @class */ (function (_super) {
    __extends(InitialStateApi, _super);
    function InitialStateApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Proxy endpoint to retrieve break fence sync status after checking sync hasn\'t completed
     * @param {Array<string>} [breakFenceIds] List of breakFenceIds to retrieve sync statuses for, if null will retrieve all for farm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InitialStateApi
     */
    InitialStateApi.prototype.listBreakFenceSyncStatuses = function (breakFenceIds, options) {
        var _this = this;
        return (0, exports.InitialStateApiFp)(this.configuration).listBreakFenceSyncStatuses(breakFenceIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Endpoint to retrieve device control statuses for devices that have unconfirmed control setting changes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InitialStateApi
     */
    InitialStateApi.prototype.listDeviceControlStatuses = function (options) {
        var _this = this;
        return (0, exports.InitialStateApiFp)(this.configuration).listDeviceControlStatuses(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve all cattle locations for the context farm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InitialStateApi
     */
    InitialStateApi.prototype.listDeviceLocations = function (options) {
        var _this = this;
        return (0, exports.InitialStateApiFp)(this.configuration).listDeviceLocations(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Endpoint to retrieve device pause sync statuses for devices that have a sync in progress
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof InitialStateApi
     */
    InitialStateApi.prototype.listDevicePauseSyncStatuses = function (options) {
        var _this = this;
        return (0, exports.InitialStateApiFp)(this.configuration).listDevicePauseSyncStatuses(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Proxy endpoint to retrieve device sync statuses filtering out break to breaks and already synced commands
     * @param {Array<string>} [serialNumbers] List of serialNumbers to retrieve sync statuses for, if null will retrieve all for farm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InitialStateApi
     */
    InitialStateApi.prototype.listDeviceSyncStatuses = function (serialNumbers, options) {
        var _this = this;
        return (0, exports.InitialStateApiFp)(this.configuration).listDeviceSyncStatuses(serialNumbers, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve device disablement status for all devices in the context farm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InitialStateApi
     */
    InitialStateApi.prototype.listDevicesDisablementStatus = function (options) {
        var _this = this;
        return (0, exports.InitialStateApiFp)(this.configuration).listDevicesDisablementStatus(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve network status for all devices in the context farm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InitialStateApi
     */
    InitialStateApi.prototype.listDevicesNetworkStatus = function (options) {
        var _this = this;
        return (0, exports.InitialStateApiFp)(this.configuration).listDevicesNetworkStatus(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return InitialStateApi;
}(base_1.BaseAPI));
exports.InitialStateApi = InitialStateApi;
/**
 * OnboardingApi - axios parameter creator
 * @export
 */
var OnboardingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompletedModules: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/bff-mobile/onboarding/modules";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isUserOnboardingPromptsEnabled: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/bff-mobile/onboarding/enablement";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {IUserOnboardingModulesDTO} [iUserOnboardingModulesDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompletedModules: function (iUserOnboardingModulesDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/bff-mobile/onboarding/modules";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUserOnboardingModulesDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {boolean} userOnboardingPromptsEnabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserOnboardingPromptsEnablement: function (userOnboardingPromptsEnabled, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'userOnboardingPromptsEnabled' is not null or undefined
                    (0, common_1.assertParamExists)('updateUserOnboardingPromptsEnablement', 'userOnboardingPromptsEnabled', userOnboardingPromptsEnabled);
                    localVarPath = "/bff-mobile/onboarding/enablement";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (userOnboardingPromptsEnabled !== undefined) {
                        localVarQueryParameter['userOnboardingPromptsEnabled'] = userOnboardingPromptsEnabled;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.OnboardingApiAxiosParamCreator = OnboardingApiAxiosParamCreator;
/**
 * OnboardingApi - functional programming interface
 * @export
 */
var OnboardingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OnboardingApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompletedModules: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCompletedModules(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isUserOnboardingPromptsEnabled: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.isUserOnboardingPromptsEnabled(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {IUserOnboardingModulesDTO} [iUserOnboardingModulesDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompletedModules: function (iUserOnboardingModulesDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCompletedModules(iUserOnboardingModulesDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {boolean} userOnboardingPromptsEnabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserOnboardingPromptsEnablement: function (userOnboardingPromptsEnabled, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateUserOnboardingPromptsEnablement(userOnboardingPromptsEnabled, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.OnboardingApiFp = OnboardingApiFp;
/**
 * OnboardingApi - factory interface
 * @export
 */
var OnboardingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OnboardingApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompletedModules: function (options) {
            return localVarFp.getCompletedModules(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isUserOnboardingPromptsEnabled: function (options) {
            return localVarFp.isUserOnboardingPromptsEnabled(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {IUserOnboardingModulesDTO} [iUserOnboardingModulesDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompletedModules: function (iUserOnboardingModulesDTO, options) {
            return localVarFp.updateCompletedModules(iUserOnboardingModulesDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {boolean} userOnboardingPromptsEnabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserOnboardingPromptsEnablement: function (userOnboardingPromptsEnabled, options) {
            return localVarFp.updateUserOnboardingPromptsEnablement(userOnboardingPromptsEnabled, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OnboardingApiFactory = OnboardingApiFactory;
/**
 * OnboardingApi - object-oriented interface
 * @export
 * @class OnboardingApi
 * @extends {BaseAPI}
 */
var OnboardingApi = /** @class */ (function (_super) {
    __extends(OnboardingApi, _super);
    function OnboardingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    OnboardingApi.prototype.getCompletedModules = function (options) {
        var _this = this;
        return (0, exports.OnboardingApiFp)(this.configuration).getCompletedModules(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    OnboardingApi.prototype.isUserOnboardingPromptsEnabled = function (options) {
        var _this = this;
        return (0, exports.OnboardingApiFp)(this.configuration).isUserOnboardingPromptsEnabled(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {IUserOnboardingModulesDTO} [iUserOnboardingModulesDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    OnboardingApi.prototype.updateCompletedModules = function (iUserOnboardingModulesDTO, options) {
        var _this = this;
        return (0, exports.OnboardingApiFp)(this.configuration).updateCompletedModules(iUserOnboardingModulesDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {boolean} userOnboardingPromptsEnabled
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    OnboardingApi.prototype.updateUserOnboardingPromptsEnablement = function (userOnboardingPromptsEnabled, options) {
        var _this = this;
        return (0, exports.OnboardingApiFp)(this.configuration).updateUserOnboardingPromptsEnablement(userOnboardingPromptsEnabled, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OnboardingApi;
}(base_1.BaseAPI));
exports.OnboardingApi = OnboardingApi;
/**
 * UpdateStreamApi - axios parameter creator
 * @export
 */
var UpdateStreamApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Retrieve a list of location updates
         * @param {Date} lastQueriedAt Only updates that have happened after this time will be returned
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationUpdateStream: function (lastQueriedAt, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'lastQueriedAt' is not null or undefined
                    (0, common_1.assertParamExists)('getLocationUpdateStream', 'lastQueriedAt', lastQueriedAt);
                    localVarPath = "/bff-mobile/location-update-stream";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (lastQueriedAt !== undefined) {
                        localVarQueryParameter['lastQueriedAt'] = (lastQueriedAt instanceof Date) ?
                            lastQueriedAt.toISOString() :
                            lastQueriedAt;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieve a list of updates
         * @param {Date} lastQueriedAt Only updates that have happened after this time will be returned
         * @param {number} [limit]
         * @param {boolean} [removeLocationAndNetworkUpdates] If true, all the location and network updates will be removed from the response. If this is true, client should retrieve location updates from \&#39;/bff-mobile/location-update-stream\&#39;. This parameter is just being used to keep backwards compatiliby and should be removed when all custmers have upgrade to use \&#39;/bff-mobile/location-update-stream\&#39; endpoint
         * @param {boolean} [removeDeviceDisablementUpdates] If true, all device disablement updates will be removed from the response. This information is currently only shown to halter users or by feature flag enablement but currently takes up the vast majority of the limit for each request, often causing a 413 to be returned instead causing a full reload of the app. This flag allows us to significantly reduce the payload sent on each update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpdateStream: function (lastQueriedAt, limit, removeLocationAndNetworkUpdates, removeDeviceDisablementUpdates, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'lastQueriedAt' is not null or undefined
                    (0, common_1.assertParamExists)('getUpdateStream', 'lastQueriedAt', lastQueriedAt);
                    localVarPath = "/bff-mobile/update-stream";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (lastQueriedAt !== undefined) {
                        localVarQueryParameter['lastQueriedAt'] = (lastQueriedAt instanceof Date) ?
                            lastQueriedAt.toISOString() :
                            lastQueriedAt;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (removeLocationAndNetworkUpdates !== undefined) {
                        localVarQueryParameter['removeLocationAndNetworkUpdates'] = removeLocationAndNetworkUpdates;
                    }
                    if (removeDeviceDisablementUpdates !== undefined) {
                        localVarQueryParameter['removeDeviceDisablementUpdates'] = removeDeviceDisablementUpdates;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.UpdateStreamApiAxiosParamCreator = UpdateStreamApiAxiosParamCreator;
/**
 * UpdateStreamApi - functional programming interface
 * @export
 */
var UpdateStreamApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.UpdateStreamApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Retrieve a list of location updates
         * @param {Date} lastQueriedAt Only updates that have happened after this time will be returned
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationUpdateStream: function (lastQueriedAt, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLocationUpdateStream(lastQueriedAt, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a list of updates
         * @param {Date} lastQueriedAt Only updates that have happened after this time will be returned
         * @param {number} [limit]
         * @param {boolean} [removeLocationAndNetworkUpdates] If true, all the location and network updates will be removed from the response. If this is true, client should retrieve location updates from \&#39;/bff-mobile/location-update-stream\&#39;. This parameter is just being used to keep backwards compatiliby and should be removed when all custmers have upgrade to use \&#39;/bff-mobile/location-update-stream\&#39; endpoint
         * @param {boolean} [removeDeviceDisablementUpdates] If true, all device disablement updates will be removed from the response. This information is currently only shown to halter users or by feature flag enablement but currently takes up the vast majority of the limit for each request, often causing a 413 to be returned instead causing a full reload of the app. This flag allows us to significantly reduce the payload sent on each update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpdateStream: function (lastQueriedAt, limit, removeLocationAndNetworkUpdates, removeDeviceDisablementUpdates, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUpdateStream(lastQueriedAt, limit, removeLocationAndNetworkUpdates, removeDeviceDisablementUpdates, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.UpdateStreamApiFp = UpdateStreamApiFp;
/**
 * UpdateStreamApi - factory interface
 * @export
 */
var UpdateStreamApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.UpdateStreamApiFp)(configuration);
    return {
        /**
         *
         * @summary Retrieve a list of location updates
         * @param {Date} lastQueriedAt Only updates that have happened after this time will be returned
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationUpdateStream: function (lastQueriedAt, limit, options) {
            return localVarFp.getLocationUpdateStream(lastQueriedAt, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a list of updates
         * @param {Date} lastQueriedAt Only updates that have happened after this time will be returned
         * @param {number} [limit]
         * @param {boolean} [removeLocationAndNetworkUpdates] If true, all the location and network updates will be removed from the response. If this is true, client should retrieve location updates from \&#39;/bff-mobile/location-update-stream\&#39;. This parameter is just being used to keep backwards compatiliby and should be removed when all custmers have upgrade to use \&#39;/bff-mobile/location-update-stream\&#39; endpoint
         * @param {boolean} [removeDeviceDisablementUpdates] If true, all device disablement updates will be removed from the response. This information is currently only shown to halter users or by feature flag enablement but currently takes up the vast majority of the limit for each request, often causing a 413 to be returned instead causing a full reload of the app. This flag allows us to significantly reduce the payload sent on each update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpdateStream: function (lastQueriedAt, limit, removeLocationAndNetworkUpdates, removeDeviceDisablementUpdates, options) {
            return localVarFp.getUpdateStream(lastQueriedAt, limit, removeLocationAndNetworkUpdates, removeDeviceDisablementUpdates, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.UpdateStreamApiFactory = UpdateStreamApiFactory;
/**
 * UpdateStreamApi - object-oriented interface
 * @export
 * @class UpdateStreamApi
 * @extends {BaseAPI}
 */
var UpdateStreamApi = /** @class */ (function (_super) {
    __extends(UpdateStreamApi, _super);
    function UpdateStreamApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Retrieve a list of location updates
     * @param {Date} lastQueriedAt Only updates that have happened after this time will be returned
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateStreamApi
     */
    UpdateStreamApi.prototype.getLocationUpdateStream = function (lastQueriedAt, limit, options) {
        var _this = this;
        return (0, exports.UpdateStreamApiFp)(this.configuration).getLocationUpdateStream(lastQueriedAt, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a list of updates
     * @param {Date} lastQueriedAt Only updates that have happened after this time will be returned
     * @param {number} [limit]
     * @param {boolean} [removeLocationAndNetworkUpdates] If true, all the location and network updates will be removed from the response. If this is true, client should retrieve location updates from \&#39;/bff-mobile/location-update-stream\&#39;. This parameter is just being used to keep backwards compatiliby and should be removed when all custmers have upgrade to use \&#39;/bff-mobile/location-update-stream\&#39; endpoint
     * @param {boolean} [removeDeviceDisablementUpdates] If true, all device disablement updates will be removed from the response. This information is currently only shown to halter users or by feature flag enablement but currently takes up the vast majority of the limit for each request, often causing a 413 to be returned instead causing a full reload of the app. This flag allows us to significantly reduce the payload sent on each update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateStreamApi
     */
    UpdateStreamApi.prototype.getUpdateStream = function (lastQueriedAt, limit, removeLocationAndNetworkUpdates, removeDeviceDisablementUpdates, options) {
        var _this = this;
        return (0, exports.UpdateStreamApiFp)(this.configuration).getUpdateStream(lastQueriedAt, limit, removeLocationAndNetworkUpdates, removeDeviceDisablementUpdates, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UpdateStreamApi;
}(base_1.BaseAPI));
exports.UpdateStreamApi = UpdateStreamApi;
